<pbc-sorter [config]="StandortsSorterConfig" [sorter]="standorts.sorter$ | async" (sorterChange)="standorts.sorter$.next($event)"></pbc-sorter>
